var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"money-filter",attrs:{"title":"가격대","sub-title":_vm.getRangeString,"sub-title-style":{
    color: '#3c6bbb',
    'font-size': '1.4rem'
  },"padding-x":"3.2rem","padding-y":"3rem","width":"40rem"}},[_c('div',{staticClass:"slider-view"},[_c('vue-slider',{attrs:{"height":10,"min":0,"max":120,"dotStyle":{
        width: '1.8rem',
        height: '1.8rem',
        border: '2px solid #3c6bbb',
        'box-shadow': 'none'
      },"processStyle":{
        'background-color': '#3c6bbb'
      },"marks":_vm.marks,"labelStyle":{
        'line-height':'100%',
        'font-size': '12px',
        'font-weight': 'bold',
        'color': '#999999'
      },"tooltip":"none"},on:{"drag-end":_vm.changedRange},model:{value:(_vm.moneyRange),callback:function ($$v) {_vm.moneyRange=$$v},expression:"moneyRange"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }